<template>
  <div>
    <div class="intro-y flex flex-col sm:flex-row items-center mt-8">
      <h2 class="text-lg font-medium mr-auto">Terms and Conditions</h2>
    </div>
    <!-- BEGIN: Invoice -->
    <div class="intro-y box overflow-hidden mt-5">
      <br />
      <pre>
        Confirmation:

        Your are about to submit the PMST file {{
          file.filename
        }} for conversion.

        Hit the confirmation button below to confirm. Once pressed your preferred payment method will be charged.

        Following conversion you will receive an email to your registered email address -  with the PMST file,
        excel conversion and tax invoice
        </pre
      >
      <div class="px-5 pb-8 text-center">
        <button
          type="button"
          class="button w-24 bg-theme-1 text-white"
          @click="submitConvert"
        >
          Confirm
        </button>
      </div>
    </div>
    <!-- END: Invoice -->
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "Confirm",
  data() {
    return {
      file: {
        filename: null
      },
      some: "sefsfsfsef",
      user: {
        email: "dlksflf@;dfs;fl"
      }
    };
  },
  mounted() {
    this.getFile();
  },
  methods: {
    // eslint-disable-next-line no-unused-vars
    submitConvert() {
      // console.log(this.$route.params.fileId);
      this.$router.push("/checkout/" + this.$route.params.fileId);
    },
    getFile() {
      // this.user = localStorage.getItem("user");
      // console.log("USEREEE");
      // console.log(this.user);
      axios
        .get("file/" + this.$route.params.fileId)
        .then(response => {
          let data = response.data;
          this.file = data[0];
        })
        .catch(function(error) {
          console.error(error.response);
        });
    }
  }
};
</script>
